<div fxLayout="column" fxFlex="100" class="charity container" fxLayoutGap="16px">
  <div fxLayout="column" fxLayoutAlign="center center" class="title-wrapper">
    <div class="img-wrapper">
      <img [src]="options?.logo" />
    </div>
    <h2>{{ options?.title }}</h2>
  </div>
  <p>
    <span [innerHTML]="shortText"></span>
    <span class="read-more" [style]="{ display: isDescriptionShorthend ? 'inline-block' : 'none' }" (click)="showText()">read more</span>
  </p>
  @if (options?.hyperlinkUrl && options?.hyperlinkDisplayedText) {
    <div fxLayout="column" fxLayoutAlign="center center" class="description-hyperlink">
      <a [href]="options?.hyperlinkUrl">
        {{ options?.hyperlinkDisplayedText }}
      </a>
    </div>
  }
  <div class="buttons" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutAlign="center center">
    <button (click)="goToFree()">
      {{ options?.buttonText || 'Free charity pickup' }}
    </button>
    <button (click)="goToPrimary(sectionType)">ReSupply priority pickup</button>
  </div>
</div>
